var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloset = function SvgCloset(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    clipPath: "url(#closet_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 1,
    x: 8.5,
    y: 7,
    rx: 0.5,
    transform: "rotate(90 8.5 7)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 1,
    x: 12.5,
    y: 7,
    rx: 0.5,
    transform: "rotate(90 12.5 7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 0v17h-1V0z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M5 .5h10A1.5 1.5 0 0 1 16.5 2v13a1.5 1.5 0 0 1-1.5 1.5H5A1.5 1.5 0 0 1 3.5 15V2A1.5 1.5 0 0 1 5 .5ZM6.5 18a.5.5 0 0 1-.5.5h-.5A.5.5 0 0 1 5 18v-1.5h1.5zM15 18a.5.5 0 0 1-.5.5H14a.5.5 0 0 1-.5-.5v-1.5H15z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "closet_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3 2a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v13a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"
  })))));
};
export default SvgCloset;